import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A longboard and a school system",
  "description": "",
  "published": "2011-09-12T00:00:00.000Z",
  "redirect_from": ["/blog/a-longboard-and-a-school-system/swizec/2438"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Coming back from the US I was left completely without `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Mode_of_transport",
        "title": "Mode of transport"
      }}>{`means of transport`}</a>{`. My `}<a parentName="p" {...{
        "href": "http://rollerblade.com",
        "title": "Rollerblade"
      }}>{`rollerblades`}</a>{`' last allowed wheel died over there so I was left with a cumulative three working wheels for the whole set. You need at least four.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/e798f70658fa4f61b0ea840ca5fcf50e_73.jpg",
        "alt": null,
        "title": "The longboard"
      }}></img></p>
    <p>{`Right before I left for the US my `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Driver%27s_license",
        "title": "Driver's license"
      }}>{`driver's licence`}</a>{` expired and I need to go see the doctor before I can get a new one - because of exams I simply couldn't be bothered with that yet.`}</p>
    <p>{`And I haven't had a bike ever since I retired the last one after twice its value went into repairs (I'm kind of hard on bikes).`}</p>
    <p>{`So today I borrowed a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Surfboard",
        "title": "Surfboard"
      }}>{`longboard`}</a>{` from @zidarsk8 ... well I say `}<em parentName="p">{`a`}</em>{` longboard, but it's really `}<em parentName="p">{`the`}</em>{` longboard because he doesn't really have any other. Really cool of him to let me borrow it for a week, two, three!`}</p>
    <p>{`Today I survived my first ride from college to home and I have to say despite nearly getting mowed down by a car a couple of times and some bruised pedestrians it went pretty well. Those things are super fun and if I can get a hang of it I might buy one of my own instead of a set of rollerblades, because it means I wouldn't have to keep lugging my shoes around ... we'll see, rollerblading is kind of super fun though ...`}</p>
    <p>{`Oh and today I discovered that I flunked one too many exams, this likely means I won't be able to get into the next year of my course and instead of being just before graduating from a masters equivalent in a year, I will be graduating from a bachelors in computer science.`}</p>
    <p>{`But this isn't over yet, school system! I won't go down without a fight!`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.thestar.com/news/article/1052107--army-of-skateboarders-takes-over-downtown-streets"
        }}>{`Army of skateboarders takes over downtown streets`}</a>{` (thestar.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.thestar.com/news/article/1025357--longboarder-hit-by-car-seriously-injured"
        }}>{`Longboarder hit by car, seriously injured`}</a>{` (thestar.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://trueslant.com/caitlinkelly/2010/07/21/longboarding-takes-off-while-b-c-mourns-28-year-old-competitor-killed-last-week/"
        }}>{`Longboarding Takes Off -- While B.C. Mourns 28-Year-Old Competitor Killed Last Week`}</a>{` (trueslant.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://wiki.answers.com/Q/What_makes_a_good_longboard"
        }}>{`What makes a good longboard`}</a>{` (wiki.answers.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=b8f04ab9-fe38-49fa-994c-eade8d20cc61",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      